import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { getStatusIcon, getSupportDetail } from "./SupportTicketHelper";
import {
  checkRole,
  formatSubcontractorName,
  formatUTCToLocal,
} from "../../../lib/Misc";
import { debounce } from "lodash";
import SupportTicketActionButton from "./SupportTicketActionButton";
import { Button } from "../../../components/ui/button";
import BootstrapTable from "react-bootstrap-table-next";
import Spin from "../../../components/Spin";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import SupportTicketView from "./SupportTicketView";
import MainBody from "../../../components/MainBody/MainBody";
import { Form, Formik } from "formik";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { Input } from "../../../components/ui/input";
import { toast } from "../../../components/ui/use-toast";
import { Loader2, LucidePlusCircle, X } from "lucide-react";
import { Badge } from "../../../components/ui/badge";
import Editor from "../../../components/Editor";
import TrustSelect from "../../../components/TrustSelect";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import Pagination from "../../../components/Pagination";
import { AddSupportTicketSchema } from "../../../lib/Validation";
const SupportTicket = ({ org = false }) => {
  const location = useLocation();
  const roleType = localStorage.getItem("roleType");
  const params = useParams();
  const trustId = params?.trust_id;
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const ticketId = query.get("ticketId");
  const navigate = useNavigate();

  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);

  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [supportTicket, setSupportTicket] = useState([]);

  const [showSupportUser, setShowSupportUser] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isFetchDataLoading, setIsFetchDataLoading] = useState();
  const [reply, setReplay] = useState(false);
  const [showView, setShowView] = useState(false);
  const [supportDetail, setSupportDetail] = useState();

  const allowedFileTypes = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "text/csv", // .csv
  ];

  const { organizationData } = useOrganization();

  const handleAddFiles = (event) => {
    const files = Array.from(event.target.files);
    const invalidFiles = files.filter(
      (file) => !allowedFileTypes.includes(file.type)
    );

    if (invalidFiles.length > 0) {
      toast({
        variant: "destructive",
        description: `Invalid file type(s): ${invalidFiles
          .map((file) => file.name)
          .join(
            ", "
          )}. Please upload PDF, images, Word, Excel, or CSV files only.`,
        duration: 3000,
      });
    } else {
      setFiles((prev) => [...prev, ...files]);
    }
  };

  // Handle file removal
  const handleRemoveFile = (fileIndex) => {
    setFiles((prevAttachments) =>
      prevAttachments.filter((_, index) => index !== fileIndex)
    );
  };

  // const roleType = localStorage.getItem('roleType');

  const fetchData = async () => {
    setIsFetchDataLoading(true);
    const userDetailData = await getSupportDetail(ticketId);
    if (userDetailData?.support_ticket_comments?.length === 1) {
      setReplay(true);
    } else {
      setReplay(false);
    }
    setSupportDetail(userDetailData);
    setIsFetchDataLoading(false);
  };

  const toggleShowModal = () => {
    if (!showView) {
      fetchData();
    } else {
      fetchSupportTickets();
      checkRole(roleType)
        ? navigate(`/admin/support-tickets`)
        : navigate(`/trusts/${trustId}/support-tickets`);
    }
    setShowView(!showView);
  };

  useEffect(() => {
    if (ticketId) {
      toggleShowModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketId]);

  const fetchSupportTickets = useCallback(
    async (passLimit, passPage) => {
      try {
        setIsDataLoading(true);
        const { data } = await get(
          `${
            checkRole(roleType) ? API.ADMIN_SUPPORT_TICKET : API.SUPPORT_TICKET
          }?search=${searchParam}&limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}${
            checkRole(roleType) ? "" : "&trust_id=" + (trustId ? trustId : "")
          }${
            checkRole(roleType)
              ? ""
              : "&organization_id=" +
                (organizationData?.organizationId
                  ? organizationData?.organizationId
                  : "")
          }`
        );
        setIsDataLoading(false);
        const userData = data.data.data;
        setSupportTicket(userData);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
      } catch (e) {
        setSupportTicket([]);
        setIsDataLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, trustId, organizationData?.organizationId]
  );

  useEffect(() => {
    fetchSupportTickets();
  }, [fetchSupportTickets]);

  const toggleSupportModal = () => {
    setShowSupportModal(!showSupportModal);
  };
  const toggleSupportUserModal = () => {
    if (!showSupportUser) {
      setFiles([]);
    }
    setShowSupportUser(!showSupportUser);
  };

  const handleUpload = async (value) => {
    setIsLoading(true);
    const formData = new FormData();
    if (!checkRole(roleType)) {
      formData.append(
        "organization_id",
        organizationData?.organizationId ? organizationData?.organizationId : ""
      );
    }
    formData.append("subject", value?.subject ? value?.subject : "");
    formData.append("message", value?.message ? value?.message : "");

    if (!checkRole(roleType)) {
      formData.append("trust_id", value?.trust_id ? value?.trust_id : "");
    }
    // formData.append("message", value);
    files.forEach((file, index) => {
      if (file !== undefined) {
        formData.append(`attachments[${index}]`, file);
      }
    });

    const config = { headers: { "Content-Type": "multipart/form-data" } };

    fileUpload(
      checkRole(roleType) ? API.ADMIN_SUPPORT_TICKET : API.SUPPORT_TICKET,
      formData,
      config
    )
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
          fetchSupportTickets();
          toggleSupportModal();
          toggleSupportUserModal();
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchSupportTickets(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchSupportTickets(limit, page);
  };

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const columns = checkRole(roleType)
    ? [
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "ID",
          dataField: "support_ticket_id",
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} !max-w-[190px] !whitespace-normal`,
          text: "Organization",
          dataField: "organization",
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} !max-w-[320px] !whitespace-normal`,
          text: "Trust",
          dataField: "trust",
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} !max-w-[320px] !whitespace-normal`,
          text: "Subject",
          dataField: "subject",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Created By",
          dataField: "created_by",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Created Date",
          dataField: "created_at",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Updated Date",
          dataField: "updated_at",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Status",
          dataField: "status",
          style: {
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
          },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Action",
          dataField: "action",
          style: {
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
          },
        },
      ]
    : [
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "ID",
          dataField: "support_ticket_id",
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} !max-w-[320px] !whitespace-normal`,
          text: "Trust",
          dataField: "trust",
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} !max-w-[320px] !whitespace-normal`,
          text: "Subject",
          dataField: "subject",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Created By",
          dataField: "created_by",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Created Date",
          dataField: "created_at",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Updated Date",
          dataField: "updated_at",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Status",
          dataField: "status",
          style: {
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
          },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          text: "Action",
          dataField: "action",
          style: {
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
          },
        },
      ];

  const supportTicketGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: supportTicket[i]?.id,
        id: supportTicket[i]?.id ? supportTicket[i]?.id : "",
        support_ticket_id: supportTicket[i]?.support_ticket_id
          ? supportTicket[i]?.support_ticket_id
          : "",
        organization: supportTicket[i]?.organization
          ? supportTicket[i]?.organization?.business_name
          : "",
        trust: supportTicket[i]?.trust
          ? formatSubcontractorName(supportTicket[i]?.trust)
          : "-",
        subject: supportTicket[i]?.subject ? supportTicket[i]?.subject : "",
        created_by: supportTicket[i]?.details?.replied_by?.first_name
          ? supportTicket[i]?.details?.replied_by?.first_name +
            " " +
            supportTicket[i]?.details?.replied_by?.last_name
          : supportTicket[i]?.details?.replied_by?.last_name,
        access_given_by: supportTicket[i]?.access_given_date
          ? supportTicket[i]?.access_given_by?.first_name
            ? supportTicket[i]?.access_given_by?.first_name +
              " " +
              supportTicket[i]?.access_given_by?.last_name
            : supportTicket[i]?.access_given_by?.last_name
          : "-",
        access_given_date: supportTicket[i]?.access_given_date
          ? supportTicket[i]?.access_given_date.split("-").reverse().join("-")
          : "-",
        access_revoke_date: supportTicket[i]?.access_revoke_date
          ? supportTicket[i]?.access_revoke_date.split("-").reverse().join("-")
          : "-",
        created_at: supportTicket[i]?.created_at
          ? formatUTCToLocal(supportTicket[i]?.created_at, true)
          : "-",
        updated_at: supportTicket[i]?.updated_at
          ? formatUTCToLocal(supportTicket[i]?.updated_at, true)
          : "-",
        status: supportTicket[i]?.status
          ? getStatusIcon(
              supportTicket[i]?.status,
              supportTicket[i]?.is_resolved
            )
          : "",
        action: (
          <SupportTicketActionButton
            supportDetails={supportTicket[i]}
            data={{ id: supportTicket[i]?.id }}
            id={supportTicket[i]?.id}
            fetchSupportTickets={fetchSupportTickets}
          />
        ),
      });
    }
    return items;
  };

  const supportTickets = supportTicketGenerator(supportTicket?.length);

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.business_name
          ? item?.business_name
          : item?.first_name
          ? item?.first_name + " " + item?.last_name
          : item?.last_name,
      }));
      setTrustListing(trustTempListing?.filter((item) => item.value !== "new") || []);
    } else {
      setTrustListing([]);
    }
  }, [trustList]);

  return (
    <MainBody
      searchParamData={searchParamData}
      handleClearSearch={handleClearSearch}
      handleSearchChange={handleSearchChange}
      actionContent={
        <div className="flex items-center gap-3 flex-wrap">
          {/* Add Beneficary */}
          {checkRole(roleType) ? (
            <></>
          ) : (
            <Button
              onClick={() => {
                toggleSupportUserModal();
              }}
            >
              <div className="flex items-center gap-1">
                <LucidePlusCircle size={18} />
                <span>Add Ticket</span>
              </div>
            </Button>
          )}
        </div>
      }
      loading={isDataLoading}
    >
      <div className="custom-table">
        <div className="table-body-class">
          <BootstrapTable
            keyField="roles_id"
            remote
            data={supportTickets}
            columns={columns}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
            rowClasses={TRClasses}
          />
        </div>

        <Pagination
          total={total}
          limit={parseInt(limit)}
          currentPage={page}
          updateLimit={handleUpdateLimit}
          updatePage={handleChangePage}
          from={from}
          to={to}
        />
      </div>

      <ResponsiveDrawerForm
        description={""}
        title={"Add Support Ticket"}
        handleOpen={() => {}}
        handleClose={() => {}}
        open={showSupportUser}
        buttonClassName={""}
        setOpen={setShowSupportUser}
        mobileCancelHidden={true}
        className={"sm:max-w-[60vw]"}
      >
        <div className="overflow-y-auto overflow-x-hidden max-h-[78vh] md:p-0 p-4">
          <Formik
            initialValues={{
              trust_id: trustId ? trustId : "",
              subject: "",
              message: "",
            }}
            validationSchema={AddSupportTicketSchema}
            validateOnChange={true}
            validateOnBlur={true}
          >
            {({
              setFieldValue,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              isValid,
            }) => (
              <Form className="entry-section email-form">
                <div className="grid p-1 gap-3">
                  {org && (
                    <div className="grid gap-2 max-w-[300px]">
                      <div className="min-w-0">
                        <Label htmlFor="trust_id">
                          <CustomLabelText
                            required={false}
                            labelText="Trust"
                            errorField={errors?.trust_id}
                            className={"mb-2"}
                          />
                        </Label>
                        <div className="relative">
                          <TrustSelect
                            orgId={
                              organizationData?.organizationId
                                ? organizationData?.organizationId
                                : ""
                            }
                            frameworkData={trustListing} // List of vendors
                            optionType="Trust"
                            handleSelect={(e) => {
                              setFieldValue("trust_id", e);
                            }}
                            name="trust_id"
                            disabled={
                              organizationData?.organizationId ? false : true
                            }
                            initialValue={
                              values?.trust_id ? values?.trust_id : ""
                            }
                            setTrustList={setTrustList} // Update vendor list as new data loads
                            setTrustLoading={setTrustLoading} // Control loading state
                            onClear={() => {
                              setFieldValue("trust_id", "");
                            }}
                            loading={trustLoading}
                            className={
                              errors?.trust_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                          {trustLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="grid gap-2">
                    <Label htmlFor="subject">
                      <CustomLabelText
                        required={true}
                        labelText="Subject"
                        errorField={errors?.subject}
                      />
                    </Label>
                    <Input
                      id="subject"
                      placeholder="Enter Subject"
                      name="subject"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.subject}
                      className={
                        errors?.subject &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2 col-span-full">
                    <Label htmlFor="message">
                      <CustomLabelText
                        labelText="Message"
                        errorField={errors?.message}
                      />
                    </Label>
                    <Editor
                      value={values?.message}
                      setValue={(data) => setFieldValue("message", data)}
                    />
                  </div>

                  <div className="form-group full-width">
                    <div className="attachment-button">
                      <input
                        type="file"
                        className="form-control"
                        multiple
                        onChange={handleAddFiles}
                        accept=".pdf, image/*, .xls, .xlsx, .doc, .docx, .csv"
                        style={{ display: "none" }}
                        id="file-input"
                      />
                      <Button
                        onClick={() =>
                          document.getElementById("file-input").click()
                        }
                        className="p-2 h-7"
                      >
                        <div className="flex items-center gap-1">
                          <LucidePlusCircle size={18} /> <span>Attachment</span>
                        </div>
                      </Button>
                    </div>
                    {files.length > 0 && (
                      <div className="flex flex-wrap gap-2 mt-2">
                        {/* New Uploads */}
                        {files.map((file, index) => (
                          <Badge
                            key={index}
                            variant="secondary"
                            className="flex items-center gap-1 pr-2"
                          >
                            <span title={file.name} className="cursor-pointer">
                              {file.name}
                            </span>
                            <X
                              className="w-4 h-4 ml-1 cursor-pointer"
                              onClick={() => handleRemoveFile(index)}
                            />
                          </Badge>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
                    <Button
                      disabled={isLoading || !isValid}
                      onClick={() => toggleSupportModal()}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="secondary"
                      className="cancel-btn ml-3"
                      onClick={() => toggleSupportUserModal()}
                    >
                      Cancel
                    </Button>
                  </div>
                  {showSupportModal && (
                    <ResponsiveDrawerForm
                      description={""}
                      title={"New Support Ticket"}
                      handleOpen={() => {}}
                      handleClose={() => {}}
                      className={"sm:max-w-1/2"}
                      open={showSupportModal}
                      buttonClassName={""}
                      setOpen={setShowSupportModal}
                      mobileCancelHidden={true}
                    >
                      {isLoading && <Spin fullscreen={true} />}
                      <div className="modal-body text-center">
                        <p>Are your sure you want to add support ticket?</p>
                        <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
                          <Button onClick={() => handleUpload(values)}>
                            OK
                          </Button>
                          <Button
                            className="reset ml-3"
                            variant="secondary"
                            onClick={toggleSupportModal}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </ResponsiveDrawerForm>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </ResponsiveDrawerForm>

      {ticketId && (
        <>
          <SupportTicketView
            showView={showView}
            setShowView={setShowView}
            toggleShowModal={toggleShowModal}
            loading={isFetchDataLoading}
            supportDetail={supportDetail}
            handleDelete={fetchSupportTickets}
            id={ticketId}
            fetchData={fetchData}
            fetchSupportTickets={fetchSupportTickets}
            setReplay={setReplay}
            reply={reply}
          />
        </>
      )}
    </MainBody>
  );
};

export default SupportTicket;
